import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/AmusementService`;


const ApiAmusementService = {
  getAll: (params) => {
    const url = `${baseServiceUrl}`;
    return ServiceApi.get(url, { params });
  },
  getServiceTemplatesAndEvents(params, config) {
    const url = `${baseServiceUrl}/getServiceTemplatesAndEvents`
    return ServiceApi.get(url, { params, ...config });
  },
  get: (id) => {
    const url = `${baseServiceUrl}/${id}`;
    return ServiceApi.get(url);
  },
  getAllServicesWithItems: (id) => {
    const url = `${baseServiceUrl}/getAllServicesWithItems`;
    return ServiceApi.get(url);
  },
  create: (params) => {
    const url = `${baseServiceUrl}/createAmusementService`;
    return ServiceApi.post(url, params);
  },
  update: (id, params) => {
    const url = `${baseServiceUrl}/updateAmusementService`;
    return ServiceApi.put(url, params);
  },
  delete: (id) => {
    const url = `${baseServiceUrl}/${id}`;
    return ServiceApi.delete(url);
  },
  getAllServices: (params) => {
    const url = `${baseServiceUrl}/getAllServices`;
    return ServiceApi.get(url, { params });
  },


  getDatesBetweenTwoDates: (params) => {
    const url = `${baseServiceUrl}/getDatesBetweenTwoDates`;
    return ServiceApi.get(url, { params });
  },
  getReserveDetails: (params) => {
    const url = `${baseServiceUrl}/getReserveDetails`;
    return ServiceApi.get(url, { params, });
  },
  updateServiceDetails: (params) => {
    const url = `${baseServiceUrl}/updateAmusementServiceDetails`;
    return ServiceApi.put(url, params);
  },
  updateAmusementReserveDetail: (params) => {
    const url = `${baseServiceUrl}/updateAmusementReserveDetail_V2`;
    return ServiceApi.put(url, params);
  },
  getAllAmusementServiceSlider: (params) => {
    const url = `${baseServiceUrl}/getAllAmusementServiceSlider`;
    return ServiceApi.get(url, { params });
  },
  createAmusementServiceSlider: (params) => {
    const url = `${baseServiceUrl}/createAmusementServiceSlider`;
    return ServiceApi.post(url, params);
  },
  deleteAmusementServiceSlider: (params) => {
    const url = `${baseServiceUrl}/deleteAmusementServiceSlider`;
    return ServiceApi.delete(url, { params });
  }, customDateInjection: (params) => {
    const url = `${baseServiceUrl}/customDateInjection`;
    return ServiceApi.post(url, params);
  },
  getAllServicesByGroupId: (params) => {
    const url = `${baseServiceUrl}/getAllServicesByGroupId`;
    return ServiceApi.get(url, { params });
  },
  changeOrderAmusementService: (params) => {
    const url = `${baseServiceUrl}/changeOrderAmusementService`;
    return ServiceApi.post(url, params);
  },
  getAmusementServiceCacheToken: () => {
    const url = `${baseServiceUrl}/getAmusementServiceCacheToken`;
    return ServiceApi.get(url);
  },
  deleteAmusementReserveDetail: (params) => {
    const url = `${baseServiceUrl}/deleteAmusementReserveDetail_V2?id=${params}`;
    return ServiceApi.delete(url, params);
  },
  getAllServicesByComplexId: (params) => {
    const url = `${baseServiceUrl}/getAllServicesByComplexId`;
    return ServiceApi.get(url, { params });
  },
  changeOrderAmusementServiceInComplex: (params) => {
    const url = `${baseServiceUrl}/changeOrderAmusementServiceInComplex`;
    return ServiceApi.post(url, params);
  },
  updateAmusementServiceDescription: params => {
    const url = `${baseServiceUrl}/updateAmusementService_V2Descriptions`;
    return ServiceApi.put(url, params);
  },
  deleteAmusementServiceDescription: params => {
    const url = `${baseServiceUrl}/deleteAmusementReserveDetail_V2Descriptions`;
    return ServiceApi.delete(url, { params });
  },
  changeOrderAmusementServiceSlider: (params) => {
    const url = `${baseServiceUrl}/changeOrderAmusementServiceSlider`;
    return ServiceApi.post(url, params);
  },
  getReserveDetailChangesHistory: (params) => {
    const url = `${baseServiceUrl}/getAmusementServiceReserveDetailChangesHistory`;
    return ServiceApi.get(url, { params });
  },
  getAllAmusementServiceBySupplierId: (params) => {
    const url = `${baseServiceUrl}/getAllAmusementServiceBySupplierId`
    return ServiceApi.get(url, { params });
  },
  deleteAmusementService: params => {
    const url = `${baseServiceUrl}/deleteAmusementService`;
    return ServiceApi.delete(url, { params });
  },
};

export default ApiAmusementService;


